import React from 'react'
import PropTypes from 'prop-types'
import { Card, Flexbox } from '@/components'
import dateMask from '@/lib/masks/date'
import currency from '@/lib/masks/currency'
import { CLINICAL_CARE_STATUS } from '@/lib/enums'

function ClinicalCareCard({ clinicalCare }) {
  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h5">Atendimento clínico</div>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-stethoscope" />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        <Flexbox.Columns className="mb-1">
          <Flexbox.Column>Status</Flexbox.Column>
          <Flexbox.Column className="col-auto text-bold">
            {CLINICAL_CARE_STATUS.t(clinicalCare?.status)}
          </Flexbox.Column>
        </Flexbox.Columns>
        <Flexbox.Columns className="mb-1">
          <Flexbox.Column>Prioridade</Flexbox.Column>
          <Flexbox.Column className="col-auto text-bold">
            {clinicalCare?.priority?.title || '-'}
          </Flexbox.Column>
        </Flexbox.Columns>
        <Flexbox.Columns className="mb-1">
          <Flexbox.Column>Classificação</Flexbox.Column>
          <Flexbox.Column className="col-auto text-bold">
            {clinicalCare?.classification?.description || '-'}
          </Flexbox.Column>
        </Flexbox.Columns>
        <Flexbox.Columns className="mb-1">
          <Flexbox.Column>Protocolo</Flexbox.Column>
          <Flexbox.Column className="col-auto text-bold">
            {clinicalCare?.protocolNumber || '-'}
          </Flexbox.Column>
        </Flexbox.Columns>
        <Flexbox.Columns className="mb-1">
          <Flexbox.Column>Valor</Flexbox.Column>
          <Flexbox.Column className="col-auto text-bold">
            {currency(clinicalCare?.price || 0)}
          </Flexbox.Column>
        </Flexbox.Columns>
        <Flexbox.Columns className="mb-1">
          <Flexbox.Column>Solicitado em</Flexbox.Column>
          <Flexbox.Column className="col-auto text-bold">
            {dateMask(clinicalCare?.createdAt, { hour: '2-digit', minute: '2-digit' })}
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Body>
    </Card.Base>
  )
}

ClinicalCareCard.propTypes = {
  clinicalCare: PropTypes.objectOf(Object).isRequired,
}

export default ClinicalCareCard
